(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-custom-collection-banner"] && !Shopify.designMode) return;
  try {
    
    function slickLargeSelComp(slickSliderContainer) {
      var windowWidth = $(window).width();
      let calSlide = windowWidth / 278;
        slickSliderContainer.slick({
          infinite: false,
          dots: false,
          slidesToShow: calSlide,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: true
        });
        slickSliderContainer.removeClass('tw-hidden');
        slickSliderContainer.removeClass('md:tw-grid');
        slickSliderContainer.removeClass('lg:tw-flex');
        slickSliderContainer.addClass('md:tw-hidden');
        slickSliderContainer.addClass('lg:tw-hidden');
        slickSliderContainer.appendTo( ".kanopi-large-selection-section .collection-banners" );
        slickSliderContainer.eq(0).slick('refresh');         
    }
    var slickSliderContainerAtLoad=$('.kanopi-large-selection-section .container-large-selection-help').clone();
    slickLargeSelComp(slickSliderContainerAtLoad);
    slickSliderContainerAtLoad.slick('slickRemove',0);

    $(window).on('resize', function(){
      let windowWidth = $(window).width();
      if  ($(window).width() <= 767 && slickSliderContainerAtLoad.hasClass('slick-initialized')) {        
      slickSliderContainerAtLoad.eq(0).slick('unslick');
      slickLargeSelComp(slickSliderContainerAtLoad.eq(0)); 
      }
    });
      slickSliderContainerAtLoad.on('reinit', function(event, slick) {
      slickSliderContainerAtLoad.slick('slickSetOption', {arrows:false, dots:false});
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  //Refresh cart page after add items to cart
  $('.grid-upsell-shopping-cart .js-add-grid-to-cart').on('click', function () {
    setTimeout(function () {
      document.location.reload(true);
    }, 600);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
    function slickLargeSelComp(slickSliderContainer) {
      var windowWidth = $(window).width();
          let calSlide = windowWidth / 316;
        slickSliderContainer.slick({
          infinite: false,
          dots: false,
          slidesToShow: calSlide,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: true
        });
        slickSliderContainer.removeClass('tw-hidden');
        slickSliderContainer.removeClass('md:tw-grid');
        slickSliderContainer.removeClass('lg:tw-flex');
        slickSliderContainer.addClass('md:tw-hidden');
        slickSliderContainer.addClass('lg:tw-hidden');
        slickSliderContainer.appendTo( ".kanopi-large-selection-section .collection-banners" );
        slickSliderContainer.eq(0).slick('refresh');         
    }
    var slickSliderContainerAtLoad=$('.kanopi-large-selection-section .container-large-selection-help').clone();
    slickLargeSelComp(slickSliderContainerAtLoad);
    slickSliderContainerAtLoad.slick('slickRemove',0);

    $(window).on('resize', function(){
      let windowWidth = $(window).width();
      if  ($(window).width() <= 767 && slickSliderContainerAtLoad.hasClass('slick-initialized')) {        
      slickSliderContainerAtLoad.eq(0).slick('unslick');
      slickLargeSelComp(slickSliderContainerAtLoad.eq(0)); 
      }
    });
      slickSliderContainerAtLoad.on('reinit', function(event, slick) {
      slickSliderContainerAtLoad.slick('slickSetOption', {arrows:false, dots:false});
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["energy-saving-calculator"]) return;
  try {
    
  window.calculatebtnflag = true;
  $(document).ready(function () {
    const ctx = document.getElementById('savingsChart').getContext('2d');
    const gradient = ctx.createLinearGradient(1200, 0, 0, ctx.canvas.height);

    gradient.addColorStop(0, 'rgba(0, 80, 50, 0.9)');
    gradient.addColorStop(1, 'rgba(0, 80, 50, 0)');

    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const fullLabels = ['1 Year', '3 Years', '6 Years', '9 Years', '12 Years', '15 Years'];
    const shortLabels = ['3 Years', '9 Years', '15 Years'];
    const fullData = [0, 27900, 55800, 83700, 111600, 139500];
    const shortData = [27900, 83700, 139500];

    const getChartData = () => ({
      labels: [],
      datasets: [{
        label: 'Total Savings',
        data: [],
        fill: true,
        backgroundColor: gradient,
        borderColor: 'rgba(0, 80, 50, 0.6)',
        borderWidth: 0.01,
        tension: 0.3,
        pointBackgroundColor: '#004D40',
        pointBorderColor: '#004D40',
        pointRadius: 0,
        pointHoverRadius: 6,
        pointStyle: 'circle',
      }]
    });

    let savingsChart = new Chart(ctx, {
      type: 'line',
      data: getChartData(),
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: { top: 40, left: 20, right: 40, bottom: 0 }
        },
        plugins: { legend: { display: false } },
        scales: {
          x: {
            grid: { display: false, drawTicks: false, drawBorder: false },
            ticks: { padding: 16, color: '#696968', font: { family: 'maison-neue-book', size: 14 } }
          },
          y: {
            beginAtZero: true,
            ticks: {
              display: !mediaQuery.matches,
              padding: 10,
              color: '#696968',
              font: {
                family: 'maison-neue-book',
                size: 14
              },
              callback: function(value, index, ticks) {
                if (!mediaQuery.matches && value === 0) return '';
                if (value === 0) return '';
                return `$${value >= 1000 ? (value / 1000).toFixed(0) + 'K' : value}`;
              }
            },
            grid: {
              drawTicks: false,
              drawBorder: false,
              color: '#d3d3d0',
              lineWidth: 1,
              display: true
            },
            afterDataLimits: (scale) => {
              const data = scale.chart.data.datasets[0].data;
              const actualMax = Math.max(...data);

              // Always start with 1000 as base step
              let step = 1000;
              let multiplier = 1;

              // Increase step if max value exceeds 6000
              while ((step * 6) < actualMax) {
                multiplier += 1;
                step = 1000 * multiplier;
              }

              // Force 6 steps of clean intervals
              scale.options.ticks.stepSize = step;
              scale.max = step * 6;
            }
          }


        }
      },
      plugins: [{
        id: 'labelPlugin',
        afterDatasetsDraw: (chart) => {
          const ctx = chart.ctx;
          const dataset = chart.data.datasets[0];
          const meta = chart.getDatasetMeta(0);
          
          dataset.data.forEach((value, index) => {
            if (!mediaQuery.matches && index === 0) return; // Skip "1 Year" label on desktop
            const point = meta.data[index].tooltipPosition();
            const label = `$${value.toLocaleString()}`;
            
            ctx.save();
            ctx.font = 'bold 20px maison-neue-book';
            const padding = 6;
            const textWidth = ctx.measureText(label).width;
            const boxWidth = textWidth + padding * 2;
            const boxHeight = 35;
            const arrowSize = 10;
            let x = point.x - boxWidth / 2;
            const y = point.y - boxHeight - 5;
            const chartWidth = chart.width;
            
            if (x + boxWidth > chartWidth) {
              x = chartWidth - boxWidth - 10;
            }
            if (x < 10) {
              x = 10;
            }

            // Draw label background
            ctx.fillStyle = 'white';
            ctx.strokeStyle = 'rgba(0,0,0,0.1)';
            ctx.lineWidth = 1;
            ctx.shadowColor = 'rgba(0,0,0,0.1)';
            ctx.shadowBlur = 4;
            ctx.shadowOffsetY = 2;

            ctx.beginPath();
            const radius = 6;
            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + boxWidth - radius, y);
            ctx.quadraticCurveTo(x + boxWidth, y, x + boxWidth, y + radius);
            ctx.lineTo(x + boxWidth, y + boxHeight - radius);
            ctx.quadraticCurveTo(x + boxWidth, y + boxHeight, x + boxWidth - radius, y + boxHeight);
            ctx.lineTo(point.x + arrowSize, y + boxHeight);
            ctx.lineTo(point.x, y + boxHeight + arrowSize);
            ctx.lineTo(point.x - arrowSize, y + boxHeight);
            ctx.lineTo(x + radius, y + boxHeight);
            ctx.quadraticCurveTo(x, y + boxHeight, x, y + boxHeight - radius);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();

            // Draw label text
            ctx.fillStyle = '#2b5f43';
            ctx.textAlign = 'center'; 
            ctx.textBaseline = 'middle'; 
            ctx.fillText(label, x + boxWidth / 2, y + boxHeight / 2); 
            ctx.restore();
          });
        }
      }]
    });

    const $buildingDropdown = $('#building-type');
    const $zipCodeInput = $('#project-location');
    const $projectSizeInput = $('#project-size');
    const $unlockBtn = $('#energy-calculator .btn');
    const $resultsBox = $('.estimated-savings');

  //  $unlockBtn.on('click',async function (e) {
    $(document).on('submit','#energy-calculator',async function(e){
      e.preventDefault();
      $(this).find('button.btn').attr('disabled',true);
      $(this).find('button.btn .before-it').addClass('tw-hidden');
      $(this).find('button.btn .after-load').addClass('tw-hidden');
      $(this).find('button.btn .after-it').removeClass('tw-hidden'); 
      let portalId = $(this).find('#portalId').val();
      let formId = $(this).find('#formId').val();
      let formdata = new FormData(document.getElementById("energy-calculator"));
      formdata.set('project_size',$('#project-size').val().replaceAll(',',''));
      let requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
      };
      $('#energy-calculator button').attr('disabled',true);
      window.projectQuoteArea = $('#energy-calculator #project-size').val().replaceAll(',','');

      const zipCode = $zipCodeInput.val();
      const buildingType = $buildingDropdown.val();
      const projectSize = parseFloat($projectSizeInput.val().replace(/,/g, '') || 0);

      if (!zipCode || !buildingType || !projectSize) return;
      var api_error_message = "Something went wrong, please try after some times."
      var result = await fetch(baseWorker+'/energy-saving-calculator', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          zipCode,
          buildingType,
          projectsize: projectSize,
          templokCoverage: 0.6,
          store: storefront_code
        })
      }).then(async function(response) {
        if(response.ok)
        {
          return response.json();         
        }
        return false;
      });
      if(result){
          const data = result.data;
          if (!data || !data.savings || !Array.isArray(data.savings)) return;

          await fetch(`https://forms.hubspot.com/uploads/form/v2/${portalId}/${formId}`, requestOptions)
          $resultsBox.removeClass('tw-hidden');
          $('.shopify-section.energy-saving-card').removeClass('tw-hidden');

          const savings = data.savings;
          const total = Math.round(savings[savings.length - 1].total);
          $('.summary-value').text(`$${total.toLocaleString()}`);

          // Dynamic labels/data
          const fullLabels = savings.map(s => `${s.year} Year${s.year > 1 ? 's' : ''}`);
          const fullData = savings.map(s => Math.round(s.cumulativeTotal));

          const totalPoints = savings.length;
          const shortLabels = [];
          const shortData = [];

          if (totalPoints >= 3) {
            shortLabels.push(`${savings[Math.floor(totalPoints * 0.2)].year} Yrs`);
            shortLabels.push(`${savings[Math.floor(totalPoints * 0.6)].year} Yrs`);
            shortLabels.push(`${savings[totalPoints - 1].year} Yrs`);

            shortData.push(Math.round(savings[Math.floor(totalPoints * 0.2)].cumulativeTotal));
            shortData.push(Math.round(savings[Math.floor(totalPoints * 0.6)].cumulativeTotal));
            shortData.push(Math.round(savings[totalPoints - 1].cumulativeTotal));
          } else {
            shortLabels.push(...fullLabels);
            shortData.push(...fullData);
          }

          const isMobile = window.innerWidth <= 520;

          savingsChart.data.labels = isMobile ? shortLabels : fullLabels;
          savingsChart.data.datasets[0].data = isMobile ? shortData : fullData;
          savingsChart.update();
          
          $('.templok-percentage-value').text($('.main-select-data option:first').attr('data-templok-ratio')+ '%');
          $('.sqft-value').text(projectSize.toLocaleString());
          $('.building-type-value').text(buildingType)
          $('.product-card-main').each(function(){
            window.updateVariantOptions($(this))
            window.updateProductCard($(this))
          })
          window.updateTemplokSlider();
          $(this).find('button.btn .before-it').addClass('tw-hidden');
          $(this).find('button.btn .after-load').removeClass('tw-hidden');
          $(this).find('button.btn .after-it').addClass('tw-hidden'); 
          calculatebtnflag = false;
          let scrolltop = $(".estimated-savings").offset().top - $('#header').height();
          document.body.scrollTop = scrolltop; // For Safari
          document.documentElement.scrollTop = scrolltop;
      }else{
        $('.zip-code .error_msg').removeClass("tw-hidden");
        $('.estimated-savings').addClass('tw-hidden');
        $('.shopify-section.energy-saving-card').addClass('tw-hidden');
        $(this).find('button.btn .before-it').removeClass('tw-hidden');
        $(this).find('button.btn .after-load').addClass('tw-hidden');
        $(this).find('button.btn .after-it').addClass('tw-hidden'); 
      }
        
    });
    $('.chat-now').click(function(){
      openLiveChat();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanopi-compatible-ceilings-tiles"] && !Shopify.designMode) return;
  try {
    
function slickCompatibleCeilingTilesComp() {
      var windowWidth = $(window).width();
      var slickSliderContainer=$('.compatible-tiles .container-compatibles-cards');
      if (windowWidth <= 767) {
        if(slickSliderContainer.hasClass('slick-initialized')){
          slickSliderContainer.slick('unslick');
          }
          const cardWidth = 252.7;
          const paddingWrapper = 19;
          let calSlide = windowWidth / (cardWidth + paddingWrapper);
        slickSliderContainer.slick({
          infinite: false,
          dots: false,
          slidesToShow: calSlide,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: true
        });
      } else{
        if(slickSliderContainer.hasClass('slick-initialized')){
        slickSliderContainer.slick('unslick');
        }
      }
    }

    slickCompatibleCeilingTilesComp();

    $(window).on('resize', function(){
      slickCompatibleCeilingTilesComp();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanopi-faq"] && !Shopify.designMode) return;
  try {
    
  $(document).on('click','.view-more-questions', function() {
    let hiddenQuestions = $('.kanopi-faqs .panel.more-questions');
    hiddenQuestions.each(function() {
      $(this).removeClass('more-questions');
      $(this).addClass('visible-more-questions');
    })

    $(this).removeClass('view-more-questions');
    $(this).addClass('view-less-questions');
    $(this).find('#faq-view-label').html('View Less')
    $(this).find('i').removeClass('ad-chevron-down');
    $(this).find('i').addClass('ad-chevron-up');
    initCollapseAcordionPosition();
  })

  $(document).on('click','.view-less-questions', function() {
    var target = $('#faqSectionBottom');
    $('html, body').animate({
      scrollTop: target.offset().top
    }, 1);
    let visibleQuestions = $('.kanopi-faqs .panel.visible-more-questions');
    setTimeout(() => {
      visibleQuestions.each(function() {
        $(this).removeClass('visible-more-questions');
        $(this).addClass('more-questions');
      });
      $(this).removeClass('view-less-questions');
      $(this).addClass('view-more-questions');
      $(this).find('#faq-view-label').html('View More');
      $(this).find('i').removeClass('ad-chevron-up');
      $(this).find('i').addClass('ad-chevron-down');      
    }, 300);
  })

  $(document).on('click','#faqContactBtn',function(){
    var target = $('#helpContactSection');
    $('html, body').animate({
      scrollTop: target.offset().top
    }, 1);
  });
  $(document).on('ready', function() {
    const numberOfMobileQuestions = 4;
    const mobileBreakPoint = 1023;
    const kanopiFaqItems = $('.js-kanopi-faqs .panel');
    if(kanopiFaqItems.length > numberOfMobileQuestions && window.innerWidth <= mobileBreakPoint) $(kanopiFaqItems[numberOfMobileQuestions]).addClass("more-questions");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanopi-have-questions"] && !Shopify.designMode) return;
  try {
    
    function slickSliderHaveQuestionsComp() {
      var windowWidth = $(window).width();
      var slickSliderContainer=$('.kanopi-have-questions-section .container-results-help');
      var centerMode = true;
      var centerPadding = '15px';
      if (windowWidth <= 535) {
        if(slickSliderContainer.hasClass('slick-initialized')){
          slickSliderContainer.slick('unslick');
          }
          let calSlide = windowWidth / 267.85;
        slickSliderContainer.slick({

          infinite: false,
          dots: true,
          slidesToShow: calSlide,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: false,
          centerMode: centerMode,
          centerPadding: centerPadding
          
        });
      var slideWidth = $('.kanopi-have-questions-section .container-results-help .slick-track .container-cards').width();
      let slickTrackMarginLeft = (windowWidth - slideWidth) / 2;
      slickTrackMarginLeft = slickTrackMarginLeft;
      slickTrackMarginLeft = (slickTrackMarginLeft-32)+'px'
      $('.kanopi-have-questions-section .container-results-help .slick-track').css('margin-left', slickTrackMarginLeft);
      } else {
        if(slickSliderContainer.hasClass('slick-initialized')){
            slickSliderContainer.slick('unslick');
          }
      }
    }
    
    slickSliderHaveQuestionsComp();
    
    $(window).on('resize', function(){
      slickSliderHaveQuestionsComp();
      
    
    });
    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanopi-popular-ceiling-tiles"] && !Shopify.designMode) return;
  try {
    
  function slickPopularTilesComp() {
    var windowWidth = $(window).width();
    var slickSliderContainer = $('.kanopi-popular-tiles-section .container-popular-tiles-help');
    if (windowWidth <= 767) {
      if (slickSliderContainer.hasClass('slick-initialized')) {
        slickSliderContainer.slick('unslick');
      }
      const cardWidth = 252;
      const paddingWrapper = 26;
      let calSlide = windowWidth / (cardWidth + paddingWrapper);
      slickSliderContainer.slick({
        infinite: false,
        dots: false,
        slidesToShow: calSlide,
        slidesToScroll: 1,
        variableWidth: false,
        arrows: true
      });
    } else {
      if (slickSliderContainer.hasClass('slick-initialized')) {
        slickSliderContainer.slick('unslick');
      }
    }
  }
  function validatePopularDiscounts() {
    const hasRegDiscount = localStorage.getItem('applyDiscount') === 'true';
    const hasVolDiscount = localStorage.getItem('applyVolDiscount') === 'true';
    const popularItems = $('.tw-popular-item');
    popularItems.each(function () {
      const $item = $(this);
      const has_discount = $item.attr('has-discount');
      const hideDiscount = () => {
        const flag = $item.find('.ribbon');
        if (flag.length) {
          flag.removeClass('tw-inline-block');
          flag.css('display', 'none');
        }
      };

      if (!hasVolDiscount) {
        $item.find('.js-popular__volume-wrapper')?.css('display', 'none');
        if (has_discount === 'false') hideDiscount();
      }
      if (!hasRegDiscount) {
        $item.find('.product-price')?.removeClass('tw-priceWithDiscount');
      }
      if (!hasVolDiscount && !hasRegDiscount) {
        hideDiscount();
      }
    });
    const hiddenItems = $(".js-initial-load");
    if(hiddenItems.length) {
      hiddenItems.removeClass("tw-hide-on-load");
    }
  }

  $(document).on('ready', function () {
    validatePopularDiscounts();
    slickPopularTilesComp();
  });
  $(window).on('resize', function () {
    slickPopularTilesComp();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanopi-tips-inspiration"] && !Shopify.designMode) return;
  try {
    
    function slickTipsnInspComp() {
      var windowWidth = $(window).width();
      var slickSliderContainer=$('.kanopi-tips-n-inspiration-section .container-tips-n-inspiration-help');
      if (windowWidth <= 767) {
        if(slickSliderContainer.hasClass('slick-initialized')){
          slickSliderContainer.slick('unslick');
          }
          let calSlide = windowWidth / 316;
        slickSliderContainer.slick({
          infinite: false,
          dots: false,
          slidesToShow: calSlide,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: true
        });
      } else{
        if(slickSliderContainer.hasClass('slick-initialized')){
        slickSliderContainer.slick('unslick');
        }
      }
    }

    slickTipsnInspComp();

    $(window).on('resize', function(){
      slickTipsnInspComp();
    });

  } catch(e) { console.error(e); }
})();
})();
